import { environment } from '../../../environments/environment';

function readRuntimeApiBaseOverride(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const w = window as unknown as { __WN_ADMIN_API_BASE__?: string };
  const v = w.__WN_ADMIN_API_BASE__?.trim();
  return v || undefined;
}

/** HR API origin (no trailing slash). Build-time `environment.apiBaseUrl` unless `window.__WN_ADMIN_API_BASE__` is set at deploy time. */
export const appEnv = {
  get apiBaseUrl(): string {
    return readRuntimeApiBaseOverride() ?? environment.apiBaseUrl;
  },
};

